import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
	requestToLogin,
	changeUserAtLoginProperties, displayInfoDialogBox, displayRejectAuthDialogBox,
	logout, requestAcceptToba, displayToba
} from "../actions/user";
import {
	changeNewSolicitorProperties, solicitorFormEmailInfo, solicitorFormEmailValidationError, solicitorFormUsernameInfo,
	solicitorFormUsernameValidationError
} from "../actions/newSolicitor";
import { push } from 'connected-react-router'
// import download from "in-browser-download";
import {isAragUser, isSolicitorUser, _getFileFromBase64} from "../helpers/functions";
import {NOT_FOUND_MESSAGE} from "../helpers/variables";

//Higher order component for user authorization handling
const Authorization = (allowedRoles) =>
	(WrappedComponent) => {
		class WithAuthorization extends Component {
			constructor(props) {
				super(props)

			}

            _isAllowedToSee = () => {
                if(isSolicitorUser(this.props.userRoles)) {return true;}
                if(isAragUser(this.props.userRoles)){
                    //can see articles?
                    if(this.props.locationPathName.includes('/articles') && !this.props.allowedToEditArticles){
                        return false;
                    }
                    //can see premium settings?
                    if(this.props.locationPathName.includes('/premium-settings') && !this.props.allowedToEditPremiumSettings){
                        return false;
                    }
                    //can see referral settings?
                    if(this.props.locationPathName.includes('/app-form-referral-settings') && !this.props.allowedToEditReferralSettings){
                        return false;
                    }
                    //can add TOBA?
                    if(this.props.locationPathName.includes('/add-toba') && !this.props.allowedToEditTobas){
                        return false;
                    }
                    //can see TOBAs?
                    if(this.props.locationPathName.includes('/tobas') && !this.props.allowedToEditTobas){
                        return false;
                    }
                }
                return true;
            };

            _getFileFromBase64 = (documentToDownload) => {
							_getFileFromBase64(documentToDownload);
            };

			render() {
				let {userRoles} = this.props;
				//check if the logged in user role matches the allowed roles for the context inside the wrapped
				//component, then the wrapped component will be rendered, else a not allowed message appears
				if (allowedRoles.find(allowedRole => userRoles.includes(allowedRole)) && this._isAllowedToSee()) {
                    return <WrappedComponent {...this.props} _getFileFromBase64={this._getFileFromBase64} />
				} else {
					return (
						<div className={"row"}>
							<h2 className="col-sm-12 applicationsAndPolicies-h2">{NOT_FOUND_MESSAGE}</h2>
						</div>
					)
				}
			}
		}

		const mapStateToProps = (state) => {
			return {
				locationPathName: state.router.location.pathname,
				userRoles: state.user.loggedInUser.roles,
				allowedToEditOtherApplications: state.user.loggedInUser.allowedToEditOtherApplications?state.user.loggedInUser.allowedToEditOtherApplications:false,
				allowedToEditPremiumSettings: state.user.loggedInUser.allowedToEditPremiumSettings?state.user.loggedInUser.allowedToEditPremiumSettings:false,
				allowedToEditReferralSettings: state.user.loggedInUser.allowedToEditReferralSettings?state.user.loggedInUser.allowedToEditReferralSettings:false,
				allowedToEditTobas: state.user.loggedInUser.allowedToEditTobas?state.user.loggedInUser.allowedToEditTobas:false,
				allowedToEditArticles: state.user.loggedInUser.allowedToEditArticles?state.user.loggedInUser.allowedToEditArticles:false
			}
		};

		const mapDispatchToProps = (dispatch) => {
			return {
			}
		};

		return connect(mapStateToProps, mapDispatchToProps)(WithAuthorization);
	};


export default Authorization;
